// src/api/merchantApi.js
import axiosInstance from './axiosInstance';

// ---------- DASHBOARD ----------
export async function getDashboardApi() {
  const res = await axiosInstance.get('api/dashboard');
  return res.data; // { success, data }
}

export async function updateOverviewApi(documentId, payload) {
  const res = await axiosInstance.put(`api/dashboard/overview/${documentId}`, payload);
  return res.data;
}

// ---------- CATALOGUE ----------
export async function createCatalogueItemApi(formData) {
  const res = await axiosInstance.post('api/dashboard/catalogue', formData, {
    headers: { 'Content-Type': 'multipart/form-data' },
  });
  return res.data; // { success, data: { item, itemId, documentId, ... } }
}

export async function updateCatalogueItemApi(id, formData) {
  const res = await axiosInstance.put(`api/dashboard/catalogue/${id}`, formData, {
    headers: { 'Content-Type': 'multipart/form-data' },
  });
  return res.data;
}

export async function deleteCatalogueItemApi(id) {
  const res = await axiosInstance.delete(`api/dashboard/catalogue/${id}`);
  return res.data;
}


// quick-info APIs
// ---------- QUICK INFO ----------
export async function updateQuickInfoTextApi(payload) {
  const res = await axiosInstance.put('api/dashboard/quickinfo', payload);
  return res.data;
}

export async function uploadQuickInfoImagesApi(formData) {
  const res = await axiosInstance.post(
    'api/dashboard/quickinfo/upload-images',
    formData,
    { headers: { "Content-Type": "multipart/form-data" } }
  );
  return res.data;
}

export async function deleteQuickInfoImageApi(id) {
  const res = await axiosInstance.delete(`api/dashboard/quickinfo/${id}`);
  return res.data;
}

// ---------- BUSINESS KEYWORDS ----------
export async function fetchKeywordsApi(search = '') {
  const res = await axiosInstance.get('api/master/business-keywords', {
    params: search ? { search } : {}
  });
  return res.data;
}

export async function createKeywordApi(name) {
  const res = await axiosInstance.post('api/master/business-keywords', { name });
  return res.data;
}

export async function updateMerchantKeywordsApi(keywordIds) {
  const res = await axiosInstance.put('api/dashboard/keywords', { keywordIds });
  return res.data;
}


const merchantApi = {
  getDashboardApi,
  updateOverviewApi,
  createCatalogueItemApi,
  updateCatalogueItemApi,
  deleteCatalogueItemApi,
  updateQuickInfoTextApi,
  uploadQuickInfoImagesApi,
  deleteQuickInfoImageApi,
  fetchKeywordsApi,
  createKeywordApi,
  updateMerchantKeywordsApi,
};

export default merchantApi;
